import Api from "./API";

// EMT email verification (OTP) for the worker RB Pay profile.
// baseURL already includes `/api/v1`, so paths are relative.

// Worker: the authenticated worker's own RB Pay profile.
// GET returns the profile (or 404 when none exists yet); POST creates it on
// first submit; PATCH updates it on edit/resubmit.
const getWorkerProfile = async () => {
  const response = await Api.axios.get("rb-pay/worker-profile/me");
  return response.data;
};

const createWorkerProfile = async (payload: any) => {
  const response = await Api.axios.post("rb-pay/worker-profile", payload);
  return response.data;
};

const updateWorkerProfile = async (payload: any) => {
  const response = await Api.axios.patch("rb-pay/worker-profile", payload);
  return response.data;
};

const requestEmtVerification = async (emtEmail: string) => {
  const response = await Api.axios.post(
    "rb-pay/worker-profile/emt-verification/request",
    { emtEmail }
  );
  return response.data;
};

const verifyEmtVerification = async (code: string) => {
  const response = await Api.axios.post(
    "rb-pay/worker-profile/emt-verification/verify",
    { code }
  );
  return response.data;
};

// Owner: copy another location's RB Pay banking setup into this location.
// `targetLocationId` is the new location; `sourceLocationId` is copied from.
const duplicateLocationSetup = async (targetLocationId: string, sourceLocationId: string) => {
  const response = await Api.axios.post(
    `rb-pay/location-profile/${targetLocationId}/duplicate`,
    { sourceLocationId }
  );
  return response.data;
};

// Owner: a location's RB Pay banking profile.
const getLocationProfile = async (locationId: string) => {
  const response = await Api.axios.get(`rb-pay/location-profile/${locationId}`);
  return response.data;
};

const createLocationProfile = async (locationId: string, payload: any) => {
  const response = await Api.axios.post(`rb-pay/location-profile/${locationId}`, payload);
  return response.data;
};

const updateLocationProfile = async (locationId: string, payload: any) => {
  const response = await Api.axios.patch(`rb-pay/location-profile/${locationId}`, payload);
  return response.data;
};

// Upload a void cheque and get back its S3 key (sent as `voidChequeS3Key` when
// creating/updating a profile).
const uploadVoidCheque = async (file: File) => {
  const formData = new FormData();
  formData.append("voidCheque", file);
  const response = await Api.axios.post("rb-pay/worker-profile/void-cheque", formData, {
    headers: { "Content-Type": "multipart/form-data; charset=utf-8;" },
  });
  return response.data;
};

export const RBPayService = {
  getWorkerProfile,
  createWorkerProfile,
  updateWorkerProfile,
  requestEmtVerification,
  verifyEmtVerification,
  duplicateLocationSetup,
  getLocationProfile,
  createLocationProfile,
  updateLocationProfile,
  uploadVoidCheque,
};
